import { render, staticRenderFns } from "./ResourceAvatar.vue?vue&type=template&id=6bd20b26&scoped=true"
import script from "./ResourceAvatar.vue?vue&type=script&lang=ts"
export * from "./ResourceAvatar.vue?vue&type=script&lang=ts"
import style0 from "./ResourceAvatar.vue?vue&type=style&index=0&id=6bd20b26&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd20b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd20b26')) {
      api.createRecord('6bd20b26', component.options)
    } else {
      api.reload('6bd20b26', component.options)
    }
    module.hot.accept("./ResourceAvatar.vue?vue&type=template&id=6bd20b26&scoped=true", function () {
      api.rerender('6bd20b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/ResourceAvatar.vue"
export default component.exports